import { employeeFlag } from "../constants/employeeFlag";

export const employeeFlagOptions = [
  { label: "CCI_INDIA", value: employeeFlag.CCI_INDIA },
  { label: "CCI_US", value: employeeFlag.CCI_US },
  { label: "IRED_INDIA", value: employeeFlag.IRED },
  { label: "IVY_CLINIC", value: employeeFlag.IVY_CLINIC },
];
